import { ComponentRegistry } from '@sg-core/resources/assets/js/libs/component-registry';

export class RduComponentRegistry extends ComponentRegistry {
  protected getModules(): Record<string, () => Promise<unknown>> {
    return import.meta.glob('/modules/SG/maisons/rdu/src/View/Components/**/*.ts');
  }
}
